import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { quoteBindAxios } from 'lib/quoteBind';
import { enqueueNotification } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

export const useUpdateLayerPremiums = () => {
  const dispatch = useDispatch();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.mutations.useUpdateLayerPremiums',
    };

    dispatch(enqueueNotification('notification.updateLayerPremiums.fail', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = () => {
    dispatch(enqueueNotification('notification.updateLayerPremiums.success', 'success'));
  };

  return useMutation(
    async ({ id, data, endorsmentId }) => {
      if (!id || !data) {
        throw new Error('Invalid data');
      }

      const url = endorsmentId ? `risks/${id}/endorsements/${endorsmentId}/layers` : `risks/${id}/layers`;

      const result = await quoteBindAxios.patch(url, data);
      return result?.data;
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
